import { Controller } from 'stimulus';
import { createDatepicker } from '@/js/modules/datepicker';

export default class extends Controller {
  static values = { clearButton: Boolean };

  connect() {
    this.datepicker = createDatepicker(this.element, { clearButton: this.clearButtonValue });
    // the library takes this label from its app-wide locale, so it is set per picker here
    this.datepicker.pickerElement.querySelector('.clear-button').textContent = 'Clear Date';
    this.element.addEventListener('changeDate', this.#dispatchNativeChangeEvent);
  }

  disconnect() {
    this.element.removeEventListener('changeDate', this.#dispatchNativeChangeEvent);
    this.datepicker?.destroy();
  }

  #dispatchNativeChangeEvent = () => {
    this.dispatch('change', { prefix: false });
  };
}
